import { marketingAdministratorRoles } from "../../config/roles";
import { RecordDefinition } from "../recordDefinition.types";
import { subscriptionGroupPageConfig } from "./subscriptionGroupPageConfig";

export const subscriptionGroupRecordDefinition: RecordDefinition = {
  path: "/email-preference-group",
  entityName: "g4c_subscriptiongroup",
  listRoute: "/email-preference-groups",
  backTitle: "Back to email preference groups",
  allowedRoles: marketingAdministratorRoles,
  config: subscriptionGroupPageConfig,
  identity: {
    titleFields: ["g4c_name"],
    fallbackTitle: "Email Preference Group",
    newRecordTitle: "New Email Preference Group",
  },
};
